<template lang="pug">
.mask
  .loading_wrapper.flex_v
    img(v-if="companyInformation.logo", :src="companyInformation.logo.image")
    .verify.d-flex.justify-content-center.align-items-center
      progress-circle
      p 正在驗證您的信箱...
</template>

<script>
import { activation } from "@/api/user";
import { getCompanyInformation } from "@/api/company";

export default {
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  data() {
    return {
      companyInformation: {},

      metaData: {
        title: "Resend Confirmation Letter ｜eGalax_eMPIA Technology Inc.",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
    this.verifyEmail();
  },
  methods: {
    initialLanguage() {
      this.getCompanyInformation();
    },
    getCompanyInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getCompanyInformation(temp).then((response) => {
        this.companyInformation = response.data;
      });
    },
    verifyEmail() {
      let inputData = {
        uid: this.$route.query.user,
        token: this.$route.query.token,
      };
      activation(inputData)
        .then(() => {
          alert("Email已驗證，請重新登入會員");
          this.$router.push({ name: "Login" });
        })
        .catch(() => {
          alert("Email驗證錯誤，請重新驗證");
          this.$router.push({ name: "Home" });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.loading_wrapper {
  @include rect(100%, 100%, rgba($color_white, 0.96));
  position: absolute;
  justify-content: center;
  align-items: center;
}

.wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, calc(50vh - 40px - 50%));
}

img {
  width: 100px;
  height: 100px;
}

.verify {
  margin-top: 20px;
}

p {
  font-size: 20px;
  margin: 0;
  margin-left: 10px;
}

@media (max-width: 767px) {
  p {
    font-size: 16px;
    margin: 0;
    margin-left: 10px;
  }
}
</style>
